export default __webpack_public_path__ + "media/images/footer/safebuy-c41a0872c9080b586148b5376d1dc8a7.svg";